import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';

import logo_atria from "../assets/images/logos/atria-white.png";
import Loading from '../components/Loading';
import { FormCorreo } from '../components/olvido/FormCorreo';
import FormActContrasenia from '../components/olvido/FormActContrasenia';
import ModalErrores from '../components/ModalErrores';


const OlvidoContrasenia = () => {

    const loading = useSelector((state) => state.loading);
    const obtencionError = useSelector((state) => state.mensajeError);
    const { isError } = obtencionError;
    const { tipoError, mensajeError } = obtencionError.dataError;

    const dataOlv = useSelector((state) => state.OlvidoContrasenia);
    const { paso } = dataOlv.dataOlvido;

    const FormularioMostrar = () => {
        switch (paso) {
            case 1:
                return <FormCorreo />
            case 2:
                return <FormActContrasenia />
            default:
                break;
        }
    }
    return (
        <section className='seccion-login'>
            <Container>
                <Row>
                    <Col className='col-informacion-pagina'>
                        <img src={logo_atria} alt="Atria" className='logo-atria' />
                        <h1 className='texto-titulo'>Crédito<br /> Automotriz ágil<br /> y flexible.</h1>
                    </Col>
                    <Col className='col-login d-flex align-items-center justify-content-center'>
                        {FormularioMostrar()}
                    </Col>
                </Row>

                <Loading show={loading} />
                <ModalErrores show={isError} tipoError={tipoError} mensajeError={mensajeError} />
            </Container>
        </section>   
    )
}

export default OlvidoContrasenia